
import { Vue, Component } from 'vue-property-decorator';
// import { getBaseInfo } from './api';
import { isMobile } from '@/common/ts/common';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component
export default class ViewHolder extends Vue {
  beforeRouteEnter(to: any, from: any, next: any) {
    if (!isMobile()) {
      return (location.href =
        'https://activity.cqcb.com/shangyou_activity/2022-lianghui-pc/');
    }
    next();
  }
  async created() {
    // const ret = await getBaseInfo();
    // console.log('base info is:', ret);
  }
}
